<button class="chat-toggle" [attr.aria-expanded]="isOpen" aria-controls="chatbot-panel" (click)="toggle()">
    {{'support' | translate}} <span class="dot"></span>
</button>

<!-- Backdrop -->
<div class="chat-backdrop" *ngIf="isOpen" (click)="!savingNewTicket && closeChat()"></div>

<!-- Chat Panel -->
<section id="chatbot-panel" class="chat-panel" [class.open]="isOpen" role="dialog" aria-label="Chatbot"
  aria-modal="true">

  <header class="chat-header">
    <div class="title">
      <span class="bubble"></span>
      {{ 'support' | translate }}
    </div>
    <button class="icon-btn" (click)="!savingNewTicket && closeChat()" aria-label="Close chat">✕</button>
  </header>

  <!-- SUCCESS STATE -->
  <ng-container *ngIf="submitSuccess; else formState">
    <div class="chat-body success-wrap">
      <!-- adjust the src path to where your GIF lives -->
      <img class="success-gif" src="../../../assets/images/sucess.gif" alt="Success" />
      <div class="success-text">{{ 'TicketAdded' | translate }}</div>
    </div>

    <footer class="chat-input success-actions">
      <button type="button" class="main_btn" (click)="createNewTicket()">
        {{ 'create_new_ticket' | translate }}
      </button>
      <button type="button" class="danger_btn" (click)="closeChat()">
        {{ 'close' | translate }}
      </button>
    </footer>
  </ng-container>

  <!-- FORM STATE -->
  <ng-template #formState>
    <form id="NewTicketForm" #NewTicketForm="ngForm" (ngSubmit)="submitTicket()">
      <div class="chat-body">
        <div class="form-icon mb-3" style="margin-top: 25px;">
          <label for="ticketSubject">{{ 'ticketSubject' | translate }}</label>
          <input
            class="form-control"
            id="ticketSubject"
            name="ticketSubject"
            placeholder="{{ 'ticketSubjectPlaceholder' | translate }}"
            type="text"
            style="padding-right: 15px;"
            [(ngModel)]="newTicket.subject"
            required
            [maxlength]="200" />
        </div>

        <div class="form-icon mb-3" style="margin-top: 25px;">
          <label for="msg">{{ 'msg' | translate }}</label>
          <textarea
            class="form-control"
            id="msg"
            name="msg"
            placeholder="{{ 'typemsg' | translate }}"
            rows="7"
            [(ngModel)]="newTicket.message"
            required></textarea>
        </div>
      </div>

      <footer class="chat-input">
        <button
          type="submit"
          class="main_btn"
          [disabled]="NewTicketForm.invalid || savingNewTicket"
          [class.spinner]="savingNewTicket">
          {{ 'send' | translate }}
        </button>
      </footer>
    </form>
  </ng-template>
</section>


<!-- 
<button class="chat-toggle" [attr.aria-expanded]="isOpen" aria-controls="chatbot-panel" (click)="toggle()">
    {{'support' | translate}} <span class="dot"></span>
</button>


<div class="chat-backdrop" *ngIf="isOpen" (click)="toggle()"></div>


<section id="chatbot-panel" class="chat-panel" [class.open]="isOpen" role="dialog" aria-label="Chatbot"
    aria-modal="true">

    <header class="chat-header">
        <div class="title">
            <span class="bubble"></span>
            {{'support' | translate}}
        </div>
        <button class="icon-btn" (click)="toggle()" aria-label="Close chat">✕</button>
    </header>

    <form id="NewTicketForm" #NewTicketForm="ngForm">
        <div class="chat-body">

            <div class="form-icon mb-3" style="margin-top: 25px;">
                <label for="ticketSubject">{{'ticketSubject' | translate}}</label>
                <input class="form-control" id="ticketSubject" name="ticketSubject" placeholder="{{'ticketSubjectPlaceholder' |translate}}" type="text" style="padding-right: 15px;"
                    [(ngModel)]="newTicket.subject" required [maxlength]="200">
            </div>

            <div class="form-icon mb-3" style="margin-top: 25px;">
                <label for="msg">{{'msg' | translate}}</label>
                <textarea class="form-control" id="msg" name="msg" placeholder="{{'typemsg' | translate}}" rows="7"
                    [(ngModel)]="newTicket.message" required></textarea>
            </div>
        </div>

        <footer class="chat-input">
            <button class="main_btn" (click)="submitTicket()" [disabled]="NewTicketForm.invalid || savingNewTicket" [class.spinner]="savingNewTicket">{{'send' | translate}}</button>
        </footer>
    </form>

</section> -->